import React from 'react'
import MicroFrontend from "../MicroFrontend"
import MicroFrontendContainer from './MicroFrontendContainer'

const NewsletterWidget = ({ history, data }) => {
    return (
        <MicroFrontendContainer
            MicroFrontend={MicroFrontend}
            history={history}
            data={data}
            name="NewsletterWidget"
            skeletonId="newsletterWidgetSkeleton"
            className='newsletter-widget-container'
        />
    )
}

export default (NewsletterWidget);
